<script context="module" lang="ts">
    export type DropDownOption = {
        text: string;
        handler: Function;
    };
</script>

<script lang="ts">
    import { clickOutside } from "../utilities/clickOutside";

    export let text: string = 'Click me';
    export let handler: Function;
    export let options: DropDownOption[] = [];
    export let color: string = '#ffffff';
    export let backgroundColor: string = '#1c5dc7';
    export let disabled: boolean = false;
    export let icon: any = null;

    let isDropDownOpen: boolean = false;
    let showIcon = !!icon;
    let showArrow = options.length > 0;

    let arrowSrc: string = 'data:image/svg+xml;base64,'+btoa('<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M480-360 280-560h400L480-360Z" fill="'+color+'"/></svg>');

    function onClick(e: any) {
        if (e.target.classList.contains('arrow')) {
            isDropDownOpen = !isDropDownOpen;
        } else if (typeof(handler) == 'function') {
            handler();
        }
    }

    function handleClickOutside() {
        isDropDownOpen = false;
    }
</script>

<button class="button dont-break" class:showIcon class:showArrow {disabled} style="background-color: {backgroundColor}; color: {color};" on:click={onClick} use:clickOutside on:click_outside={handleClickOutside}>
    {#if icon}
        <icon>
            {#if typeof(icon) == 'string'}
                <img src="{icon}" alt="{text}"/>
            {:else}
                <svelte:component this={icon.name} {...icon.props}/>
            {/if}
        </icon>
    {/if}
    <div class="text">{text}</div>
    {#if options.length}
        <div class="arrow" style="background-image: url({arrowSrc});"></div>
        {#if isDropDownOpen}
            <div class="dropdown">
                {#each options as option}
                    <button class="option" on:click={() => {
                        isDropDownOpen = false;
                        option.handler();
                    }}>{option.text}</button>
                {/each}
            </div>
        {/if}
    {/if}
</button>

<style>
    .button {
        display: flex;
        flex-shrink: 0;
        padding: 0 12px;
        border-radius: 5px;
        border: none;
        cursor: pointer;
        font-size: 16px;
        min-width: 140px;
        min-height: 32px;
        position: relative;
        align-items: center;
        gap: 12px;
        overflow: visible;
    }
    .button.showArrow {
        padding-right: 0;
    }
    .button[disabled] {
        background-color: var(--automapa-grey-dark);
        cursor: not-allowed;
    }
    .text {
        flex: 1;
    }
    .arrow {
        border-width: 0 0 0 1px;
        border-style: solid;
        width: 36px;
        background-position: 50% 50%;
        align-self: stretch;
    }
    .dropdown {
        z-index: 5;
        padding: 8px;
        background-color: white;
        color: black;
        border-radius: 6px;
        font-size: 13px;
        position: absolute;
        right: 0;
        top: 35px;
        box-shadow: -1px 11px 31px -10px rgba(0, 0, 0, 0.75);
        min-width: 130px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        row-gap: 6px;
    }
    .dropdown button {
        list-style: none;
        min-width: 130px;
        cursor: pointer;
        border-radius: 3px;
        padding: 7px 14px;
        border: 0;
        background-color: inherit;
        text-align: left;
    }
    .dropdown button:hover {
        background-color: var(--main-selected-background);
    }
</style>
